import { useTheme } from '@mui/material/styles'
import * as React from 'react'
import Grid from '@mui/material/Grid'
import { BillToCardBasic } from '@user/components/Location/BillToCardBasic/BillToCardBasic'
import { DiscountCodeCardSmall } from '@user/components/DiscountCodes/DiscountCodeCardSmall/DiscountCodeCardSmall'
import { Props as UpdateReferralProps } from '../../UpdateReferral'
import { getStyles } from './hooks/useStyles'
import { EntityDetailsDiscountCodeCardSmall } from '@user/features/EntityDetails/components'
import { PreviewVariants } from './typings'
import { IReferral } from '@sales-center/common'

type Props = Pick<
  UpdateReferralProps,
  'billToCardWidth' | 'billToCardMaxWidth'
> & {
  referral: IReferral
  variant: PreviewVariants
}

export function CustomerPreview(props: Props) {
  const { referral, billToCardWidth, billToCardMaxWidth, variant } = props

  const theme = useTheme()
  const styles = getStyles(theme)
  return (
    <>
      <Grid
        sx={styles.billToContainer}
        item
        style={{ paddingTop: theme.spacing(2) }}
      >
        {referral && referral.referralValue && (
          <BillToCardBasic
            billToId={referral.referralValue}
            maxWidth={billToCardMaxWidth}
            width={billToCardWidth}
          />
        )}
      </Grid>
      <Grid
        sx={styles.discountInfoContainer}
        item
        style={{ paddingTop: theme.spacing(2) }}
      >
        {variant === 'entityAdd' ? (
          <EntityDetailsDiscountCodeCardSmall
            discountCodeId={referral.referralDiscountId}
          />
        ) : (
          <DiscountCodeCardSmall discountCodeId={referral.referralDiscountId} />
        )}
      </Grid>
    </>
  )
}
